import { LoginUserDto } from "../entities/dto/auth.dto";
import { CreateUserDto } from "../entities/dto/user.dto";
import { LoginResponse } from "../entities/interfaces/auth";
import { User } from "../entities/interfaces/users";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (): Promise<ApiResponse<User[]>> => {
  return await Api.get("/users");
};

export const create = async (
  createUserDto: CreateUserDto
): Promise<ApiResponse<User[]>> => {
  return await Api.post("/users", createUserDto);
};

export const update = async (
  id: string,
  updateUserDto: CreateUserDto
): Promise<ApiResponse<User[]>> => {
  return await Api.patch(`/users/${id}`, updateUserDto);
};

const UserService = { list, create, update };
export default UserService;
